import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { InformationBoxComponent } from '@principle-theorem/ng-principle-shared';
import { type IDepositMetadata } from '@principle-theorem/principle-core/interfaces';
import { DepositStatusChipComponent } from '../scheduling/deposit-status-chip/deposit-status-chip.component';

/**
 * The one card answering "what happens to the existing deposit because of this
 * scheduling decision?", shared by the cancel and reschedule surfaces.
 *
 * The decision control itself is projected rather than owned, because each
 * surface binds it to its own form: the cancel page through a
 * `formControlName` inside its form group, the manage page through a
 * standalone `formControl`. Projecting keeps the card free of form concerns
 * and lets each caller keep its own binding.
 *
 * Gated on the appointment's deposit metadata alone, never on whether the
 * projected control resolved anything. A deposit with no request behind it
 * still has a status worth showing.
 */
@Component({
  selector: 'pr-appointment-deposit-decision',
  templateUrl: './appointment-deposit-decision.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DepositStatusChipComponent, InformationBoxComponent],
  host: { class: 'block' },
})
export class AppointmentDepositDecisionComponent {
  readonly depositMetadata = input<IDepositMetadata>();
  readonly summary = input<string>();
  readonly warning = input<string>();
}
